import { createAsyncThunk } from '@reduxjs/toolkit';
import { rejectServerError } from './thunkUtils';
import { getDeviceTypeMap } from 'services/devices/devices.service';

// Fetch the device type map used for device categorization.
export const fetchDeviceTypeMap = createAsyncThunk(
  'integration/fetchDeviceTypeMap',
  async (_, { rejectWithValue }) => {
    const res = await getDeviceTypeMap();
    if (res?.status !== 200) return rejectServerError(rejectWithValue);
    return res?.data?.result;
  },
);
